/* eslint-disable */
import { fromJS } from "immutable";
import { postReservation, postPCITransaction, createPaymentOrder } from "../../utils/witbookingApi";

import { name } from "./__init__";
import constants from "../../utils/constants";
import { actions as appActions } from "../App";
import {
  customFormObjectToString,
  removeFromSessionStorage,
  getFromLocalStorage,
} from "../../utils/misc";
import moment from "moment";

const CREATE_RESERVATION = `${name}/CREATE_RESERVATION`;
const CREATE_RESERVATION_SUCCESS = `${name}/CREATE_RESERVATION_SUCCESS`;
const CREATE_RESERVATION_ERROR = `${name}/CREATE_RESERVATION_ERROR`;

const CREATE_PCI_PROXY_TRANSACTION = `${name}/CREATE_PCI_PROXY_TRANSACTION`;
const CREATE_PCI_PROXY_TRANSACTION_SUCCESS = `${name}/CREATE_PCI_PROXY_TRANSACTION_SUCCESS`;
const CREATE_PCI_PROXY_TRANSACTION_ERROR = `${name}/CREATE_PCI_PROXY_TRANSACTION_ERROR`;

const CREATE_PNPV2_PAYMENT_ORDER_SUCCESS = `${name}/CREATE_PNPV2_PAYMENT_ORDER_SUCCESS`;
const CREATE_PNPV2_PAYMENT_ORDER_ERROR = `${name}/CREATE_PNPV2_PAYMENT_ORDER_ERROR`;
const SET_PNPV2_SECURE_PAYMENT = `${name}/SET_PNPV2_SECURE_PAYMENT`;

const SET_FORM_ASYNC_VALIDATION_ERRORS = `${name}/SET_FORM_ASYNC_VALIDATION_ERRORS`;

const CLEAR_DATA = "CLEAR_DATA";

export const initialState = fromJS({
  ticker: null,
  reservationResource: false,
  reservationARI: false,
  pciProxyResponse: false,
  pciProxyError: false,
});
export function onCreateReservation() {
  return {
    type: CREATE_RESERVATION,
  };
}
export function createReservationSuccess(resource, clearCart) {
  return {
    type: CREATE_RESERVATION_SUCCESS,
    resource,
    clearCart,
  };
}
export function createReservationError(error) {
  return {
    type: CREATE_RESERVATION_ERROR,
    error,
  };
}

export function createPCIProxySuccess(response) {
  return {
    type: CREATE_PCI_PROXY_TRANSACTION_SUCCESS,
    response,
  };
}

export function createPCIProxy(response) {
  return {
    type: CREATE_PCI_PROXY_TRANSACTION,
    response,
  };
}

export function createPCIProxyError(error) {
  return (dispatch, getState) => {
    dispatch(appActions.globalLoading(false));
    dispatch(createPCIProxyErrorWithoutDisablingLoading(error));
  };
}

export function createPCIProxyErrorWithoutDisablingLoading(error) {
  return {
    type: CREATE_PCI_PROXY_TRANSACTION_ERROR,
    error,
  };
}

export function createPnPV2PaymentOrderSuccess(response) {
  return {
    type: CREATE_PNPV2_PAYMENT_ORDER_SUCCESS,
    response,
  };
}

export function createPnPV2PaymentOrderError(error) {
  return {
    type: CREATE_PNPV2_PAYMENT_ORDER_ERROR,
    error,
  };
}

export function setPnpV2SecurePayment({ token, redirectionURL }) {
  return {
    type: SET_PNPV2_SECURE_PAYMENT,
    token,
    redirectionURL,
  };
}

export function tokenizePnPV2Error(error) {
  return dispatch => {
    dispatch(appActions.globalLoading(false));
    dispatch(createPnPV2PaymentOrderError(error));
  };
}

export function setFormAsyncValidationErrors(errors) {
  return {
    type: SET_FORM_ASYNC_VALIDATION_ERRORS,
    errors,
  };
}

export function pnpV2FormValidationErrors(errors) {
  return dispatch => {
    dispatch(setFormAsyncValidationErrors(errors));
  };
}

export function isReservationARILoaded(globalState) {
  return globalState[name] && globalState[name].get("reservationARI");
}

function formatExpireDate({ expirationMonth, expirationYear }) {
  if (!expirationMonth || !expirationYear) {
    return null;
  }
  let formattedExpirationMonth = expirationMonth;
  let formattedExpirationYear = expirationYear.substr(-2, 2);
  if (expirationMonth.length <= 1) {
    formattedExpirationMonth = `0${expirationMonth}`;
  }
  return `${formattedExpirationMonth}${formattedExpirationYear}`;
}
function getStandardCardCode(rawCardCode) {
  switch (rawCardCode) {
    case "Visa":
      return "VI";
    case "MasterCard":
      return "MC";
    case "AmericanExpress":
      return "AX";
    case "American Express":
      return "AX";
    case "Discover Card":
      return "DS";
    case "Diners Club International":
      return "DN";
    case "Maestro":
      return "MA";
    case "Bank Card":
      return "BC";
    case "Carte Bleu":
      return "BL";
    case "Carte Blanche":
      return "CB";
    case "Diners Club":
      return "DN";
    case "Eurocard":
      return "EC";
    case "Japanese Credit Bureau Credit Card":
      return "JC";
    case "Master Card":
      return "MC";
    case "Solo":
      return "SO";
    case "Union Pay":
      return "CU";
    case "Universal Air Travel Card":
      return "TP";
    case "Visa Electron":
      return "VE";
    default:
      return "VI";
  }
}

export function submitPCIProxyTransaction({
  reservationId,
  transactionId,
  propertyTicker,
  ccHolderName,
  ccType,
  expirationMonth,
  expirationYear,
}) {
  //TODO: handle success
  //TODO: handle error

  return (dispatch, getState) => {
    const expireDate = formatExpireDate({
      expirationMonth: expirationMonth,
      expirationYear: expirationYear,
    });
    const cardHolderName = ccHolderName;
    const cardCode = ccType && getStandardCardCode(ccType);
    dispatch(createPCIProxy());
    postPCITransaction(
      { dispatch, getState },
      {
        reservationId,
        transactionId,
        propertyTicker,
        expireDate,
        cardHolderName,
        cardCode,
      }
    )
      .then(() => {
        //FIXME: what will the response have?
        dispatch(createPCIProxySuccess({ reservationId }));
        dispatch(appActions.globalLoading(false));
      })
      .catch(err => {
        dispatch(createPCIProxyErrorWithoutDisablingLoading(err));
        dispatch(appActions.globalLoading(false));
      });
  };
}

export function createPnPV2PaymentOrder({ propertyTicker, reservationId, orderId }) {
  return (dispatch, getState) => {
    createPaymentOrder(
      { dispatch, getState },
      {
        propertyTicker,
        reservationId,
        orderId,
      }
    )
      .then(response => {
        if (response && response.data) {
          if (response.data.successfulPayment) {
            dispatch(createPnPV2PaymentOrderSuccess());
          } else {
            dispatch(createPnPV2PaymentOrderError(true));
          }
        }

        dispatch(appActions.globalLoading(false));
      })
      .catch(error => {
        if (error && error.response && error.response.status === 402) {
          error.response.json().then(data => {
            if (data && data.redirectionURL) {
              dispatch(
                setPnpV2SecurePayment({
                  redirectionURL: data.redirectionURL,
                })
              );
            }
          });
        } else {
          dispatch(createPnPV2PaymentOrderError(error));
        }

        dispatch(appActions.globalLoading(false));
      });
  };
}

function generateComments(formData, customFormValues, reservations) {
  let comments = "";
  comments += (formData.comments && formData.comments.length > 0 && formData.comments + "\n") || "";

  comments += customFormObjectToString(customFormValues);

  reservations.forEach(reservation => {
    if (reservation.guestAgesText) {
      comments += reservation.guestAgesText + "\n";
    }

    if (reservation.selectedServices) {
      Object.values(reservation.selectedServices).forEach(selectedServices => {
        if (selectedServices.formValues) {
          comments += `\n${selectedServices.name}${customFormObjectToString(
            selectedServices.formValues
          )}`;
        }
      });
    }
  });

  return comments;
}

export function createReservation({
  formData,
  cart,
  paymentType,
  propertyTicker,
  currency,
  locale,
  promoCodes,
  referrer,
  affiliate,
  trackingData,
  customFormValues,
  paymentTicker,
  deviceInfo,
  trackerInfo,
  ipInfo,
  recaptchaToken,
  tags,
  origin,
  mode,
}) {
  return (dispatch, getState) => {
    dispatch(setFormAsyncValidationErrors(false));

    if (!cart || !cart.reservations) {
      /* TODO: Dispatch error, empty reservations */
      return;
    }
    dispatch(appActions.globalLoading(true));
    dispatch(onCreateReservation());
    const reservations = cart.reservations.toJS();

    const comments = generateComments(formData, customFormValues, reservations);

    let phone = formData.phone;
    const phonePresent =
      customFormValues &&
      Object.values(customFormValues).find(data => data.fieldObject.widget === "PHONE");
    if (formData.phone) {
      const phonePrefix = formData.phonePrefix || "+34";
      phone = phonePrefix + " " + formData.phone.replace(/\s+/g, "");
    } else if (
      phonePresent &&
      phonePresent.value &&
      phonePresent.value.prefix &&
      phonePresent.value.number
    ) {
      phone = phonePresent.value.prefix + " " + phonePresent.value.number;
    }
    const sessionID = getFromLocalStorage(constants.LOCAL_STORAGE_KEYS.SESSION_ID);
    const reservationData = {
      recaptchaToken,
      customer: {
        name: formData.name,
        lastName: formData.lastName,
        email: formData.email,
        address: formData.address,
        country: formData.country,
        phone,
        documentId: formData.idDocument,
      },
      comments: comments,
      hidePrice: cart.hidePrice,
      sessionID: sessionID,
      tags: tags ? tags : [],
      receiveNewsLetter: !!formData.newsletter,
      paymentData: {
        hasAcceptedConditions: true,
        paymentType: paymentTicker,
      },
      hotelTicker: propertyTicker,
      reservations: reservations.map(reservation => ({
        ticker: reservation.inventory.ticker,
        totalRate: {
          currency: currency,
          amount: reservation.originalTotalRate,
        },
        startDate: moment(reservation.startDate).format("YYYY-MM-DD"),
        endDate: moment(reservation.endDate).format("YYYY-MM-DD"),
        quantity: reservation.numberOfUnits,
        selectedServices:
          reservation.selectedServices &&
          Object.keys(reservation.selectedServices).reduce((accumulator, serviceTicker) => {
            const service = reservation.selectedServices[serviceTicker];

            return [
              ...accumulator,
              {
                ticker: service.ticker,
                dateQuantity: service.dateQuantity,
              },
            ];
          }, []),
        additionalRequests: {
          arrivalTime: formData.arrivalTime,
          smoking_preference: formData.smokingPreference,
        },
        guestAges: reservation.guestAges,
        selectedPackage: reservation.selectedPackage
          ? {
              ticker: reservation.selectedPackage.ticker.replace("package_", ""),
            }
          : {},
      })),
      language: locale,
      referrer,
      affiliate,
      trackerInfo,
      locationInfo: {
        countryCode: ipInfo && ipInfo.get("country"),
        cityName: ipInfo && ipInfo.get("cityName"),
      },
    };

    const formattedMonth =
      formData.expirationMonth &&
      (formData.expirationMonth[0] === "0"
        ? formData.expirationMonth.slice(1)
        : formData.expirationMonth);

    if (paymentType === constants.PAYMENT_TYPES.CREDIT_CARD_VAULT) {
      reservationData.paymentData.creditCard = {
        holderName: formData.ccHolderName,
        type: formData.ccType,
        number: formData.ccNumber,
        securityCode: null,
        expiringMonth: formattedMonth,
        expiringYear: formData.expirationYear && formData.expirationYear.substr(-2),
      };
    } else {
      reservationData.paymentData.creditCard = {
        holderName: "-",
        type: "Visa",
        number: "4111111111111111",
        securityCode: null,
        expiringMonth: "12",
        expiringYear: "25",
      };
    }

    /** TRACKING DATA **/
    // TODO: this is a hack to not set trackingData when it is a Immutable.Map
    if (trackingData && trackingData.size !== 0) {
      reservationData.trackingData = trackingData;
    } else {
      reservationData.trackingData = {};
    }

    // If trackingData was not set on state then get from global variable ga
    reservationData.trackingData.host = reservationData.trackingData.host || constants.DEFAULT_HOST;

    let sufix = ""; // eslint-disable-line

    if (window) {
      reservationData.trackingData.host = window.location.hostname;

      if (!window.ga || typeof window.ga.getByName !== "function") {
        window.ga =
          window.ga ||
          function () {
            (ga.q = ga.q || []).push(arguments);
          };
        window.ga.l = +new Date(); // eslint-disable-line
        sufix = "-gacreated";
      }

      if (window.ga && typeof window.ga.getByName === "function") {
        reservationData.trackingData.gaClientId =
          reservationData.trackingData.gaClientId ||
          (window.ga.getByName("tgaclient") && window.ga.getByName("tgaclient").get("clientId"));
        if (!reservationData.trackingData.gaClientId) {
          reservationData.trackingData.gaClientId =
            window.ga.getByName("tgaown") && window.ga.getByName("tgaown").get("clientId");
        }

        try {
          if (!reservationData.trackingData.gaClientId) {
            reservationData.trackingData.gaClientId = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
              /[xy]/g,
              c => {
                const r = (Math.random() * 16) | 0,
                  v = c == "x" ? r : (r & 0x3) | 0x8;
                return v.toString(16);
              }
            );
            reservationData.trackingData.gaClientId += "-inner" + sufix;
          }
        } catch (exception) {
          console.log(exception);
        }

        reservationData.trackingData.gaReferrer =
          reservationData.trackingData.gaReferrer ||
          (window.ga.getByName("tgaclient") && window.ga.getByName("tgaclient").get("referrer"));
        if (!reservationData.trackingData.gaReferrer) {
          reservationData.trackingData.gaReferrer =
            window.ga.getByName("tgaown") && window.ga.getByName("tgaown").get("referrer");
        }
      }

      try {
        if (!reservationData.trackingData.gaClientId) {
          reservationData.trackingData.gaClientId = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
            /[xy]/g,
            c => {
              const r = (Math.random() * 16) | 0,
                v = c == "x" ? r : (r & 0x3) | 0x8;
              return v.toString(16);
            }
          );
          reservationData.trackingData.gaClientId += "-in" + sufix;
        }
      } catch (exception) {
        console.log(exception);
      }
    }

    if (!reservationData.trackingData.gaReferrer) {
      reservationData.trackingData.gaReferrer = document.referrer;
    }

    try {
      if (!reservationData.trackingData.gaClientId) {
        reservationData.trackingData.gaClientId = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
          /[xy]/g,
          c => {
            const r = (Math.random() * 16) | 0,
              v = c == "x" ? r : (r & 0x3) | 0x8;
            return v.toString(16);
          }
        );
        reservationData.trackingData.gaClientId += "-out" + sufix;
      }
    } catch (exception) {
      console.log(exception);
    }
    /** END TRACKING DATA **/

    reservationData.promoCodes = (promoCodes && promoCodes.replaceAll("ñ", "n").split(",")) || [];
    reservationData.deviceInfo = deviceInfo;
    reservationData.origin = origin;
    reservationData.mode = mode;
    postReservation({ dispatch, getState }, { reservationData })
      .then(({ resource }) => {
        dispatch(appActions.createdReservation(resource, paymentType));
        const clearCart = paymentType !== constants.PAYMENT_TYPES.PAY_NO_PAIN_V2;
        dispatch(createReservationSuccess(resource, clearCart));
        //TODO: ONLY DO THIS IS PAYMENT METHOD IS CC_GUARANTEE
        if (
          paymentType !== constants.PAYMENT_TYPES.PCI_PROXY &&
          paymentType !== constants.PAYMENT_TYPES.PAY_NO_PAIN_V2 &&
          paymentType !== constants.PAYMENT_TYPES.PAY_NO_PAIN_PROXY
        ) {
          dispatch(appActions.globalLoading(false));
        }
      })
      .catch(err => {
        console.log("ERROR");
        console.log(err);
        dispatch(createReservationError(err));
      });
  };
}

export default (state = initialState, action) => {
  switch (action.type) {
    case CREATE_RESERVATION_SUCCESS: {
      if (action.clearCart) {
        removeFromSessionStorage(constants.LOCAL_STORAGE_KEYS.CART);
        removeFromSessionStorage(constants.LOCAL_STORAGE_KEYS.HEARTBEAT_LOYALTY_DATA);
        removeFromSessionStorage(constants.LOCAL_STORAGE_KEYS.HEARTBEAT_LAST_BOOKING_CART_DATA);
      }
      return state.set("reservationResource", action.resource).set("loading", false);
    }
    case CREATE_PCI_PROXY_TRANSACTION:
      return state.set("pciProxyResponse", false).set("pciProxyError", false);
    case CREATE_PCI_PROXY_TRANSACTION_SUCCESS:
      return state.set("pciProxyResponse", true);
    case CREATE_PCI_PROXY_TRANSACTION_ERROR:
      return state.set("pciProxyError", action.error).set("loading", false);
    case CREATE_PNPV2_PAYMENT_ORDER_SUCCESS:
      removeFromSessionStorage(constants.LOCAL_STORAGE_KEYS.CART);
      removeFromSessionStorage(constants.LOCAL_STORAGE_KEYS.HEARTBEAT_LOYALTY_DATA);
      removeFromSessionStorage(constants.LOCAL_STORAGE_KEYS.HEARTBEAT_LAST_BOOKING_CART_DATA);
      return state.set("pnpV2PaymentOrderSuccess", true);
    case CREATE_PNPV2_PAYMENT_ORDER_ERROR:
      return state.set("pnpV2PaymentOrderError", action.error);
    case SET_PNPV2_SECURE_PAYMENT:
      return state.set("pnpV2PaymentToken", {
        token: action.token,
        redirectionURL: action.redirectionURL,
      });
    case SET_FORM_ASYNC_VALIDATION_ERRORS:
      return state.set("formAsyncValidationErrors", action.errors);
    case CREATE_RESERVATION_ERROR:
      return state.set("error", action.error).set("loading", false);
    case CREATE_RESERVATION:
      return state.set("reservationResource", false).set("loading", true);
    case CLEAR_DATA:
      return state
        .set("reservationResource", false)
        .set("pnpV2PaymentOrderSuccess", false)
        .set("pnpV2PaymentOrderError", false);
    default:
      return state;
  }
};

export const actions = {
  createPCIProxy,
  createReservation,
  createPCIProxyError,
  submitPCIProxyTransaction,
  createPnPV2PaymentOrder,
  createPnPV2PaymentOrderSuccess,
  createPnPV2PaymentOrderError,
  pnpV2FormValidationErrors,
  tokenizePnPV2Error,
};
